import { Component, OnInit, ViewChild } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
declare var app;
@Component({
  selector: 'app-a2-product-distribution',
  templateUrl: './a2-product-distribution.component.html',
  styleUrls: ['./a2-product-distribution.component.scss']
})
export class A2ProductDistributionComponent extends GridBaseCase {
  month: any = new Date();
  segmentVal: any = 0;
  typeout: any = null;
  searchDate = null;
  searcholdDate = null;
  dataArrayList: Array<any> = [];
  submitArray: Array<any> = [];
  isbutton: boolean = false;
  pageName: string = null;
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  searchValue:string = null;//查询内容
  isProduct: boolean = false;
  tabsIndex:number = 0;
  checkArrayList:Array<any> = new Array<any>();//选择的对象
  constructor(
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base: BaseModal
  ) {
    super();
    // debugger;
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    if(this.pageName=="Producthtml"){
      this.baseService.FixedSubmitBtn.configName = "ProductDistributionHtml";
      this.baseService.FixedSubmitBtn.type = 12;
    }else{
      this.baseService.FixedSubmitBtn.configName = "ProductDistribution";
      this.baseService.FixedSubmitBtn.type = 11;
    }
    this.baseService.FixedSubmitBtn.isShow = true;
    this.baseService.FixedSubmitBtn.text = "确认分销";
    this.baseService.FixedSubmitBtn.count=0;
  }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      if (that.infiniteScroll) {
        that.infiniteScroll.disabled = true;
      }

    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
       /**
   * 搜索事件
   * @param e 
   */
  serarEvent(e,type:string = 'type'){ 
    const that = this;
    if(e.keyCode == 13 || type=='search'){
      that.baseService.FixedSubmitBtn["isCheckAll"] = false;
     
      that.LoadData(1);
    }
  }
        /**
   * 下拉刷新数据
   * @param event
   */
  doRefresh(event){
    const that=this;
    that.tabsIndex = 0;
      that.LoadData(1);

    event.target.pullMax=500;
    event.target.pullMin=100;
    event.target.complete();
  }
  // 类别切换
  ipcConten(item,num){
    const that = this;
    that.tabsIndex= num;
    that.checkArrayList=item["DetailList"]||[];
  }
  LoadData(PageNumber) {
    let that = this;
    
    // console.log(that.element);
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.dataArrayList = [];
      that.checkArrayList=[];
      if(that.pageName!="Producthtml"){
        sessionStorage.removeItem("catlist");
      }
      that.baseService.FixedSubmitBtn.count=0;
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    if(that.pageName=="Producthtml"){
      let _temp:Array<any> = JSON.parse(sessionStorage.getItem("catlist"))||[];
      if(_temp.length>0){
        _temp.forEach(p=>{
           p.a_isdistributed=true;
        });
        that.baseService.FixedSubmitBtn.count=_temp.length;
        that.dataArrayList = _temp;
        that.infiniteScroll.disabled = true;
        that.loading = true;
        if (that.infiniteScroll) {
          that.infiniteScroll.complete();
        }
      }
      return;
    }
    // console.log(that.element);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    } else {
      that.msg.Alert("服务端数据配置有误,请联系管理员");
      return;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    // body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if(that.searchValue){
      let _obj={};
      _obj["SearchName"]=that.searchValue.trim();
      body.RequestBody = JSON.stringify(_obj);
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      that.loading = true;
      if (PageNumber == 1) {
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
      
      } else {
        if (that.infiniteScroll) {
          that.infiniteScroll.complete();
        }
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        let _isCheckAll = true;
        let num=that.baseService.FixedSubmitBtn.count;
        if(that.pageName!="Producthtml"){
          data.Status.Datas.forEach(function (item) {
            item.DetailList.forEach(list=>{
              if(list.a_isdistributed){
                that.bindSeesionLinkList(list,true);
              }else{
                list.a_isdistributed = false;
                _isCheckAll = false;
              }
               
            });
            that.dataArrayList.push(item);
          });
          if(data.Status.Datas.length>0){
            that.checkArrayList=data.Status.Datas[0]["DetailList"];
          }
        }else{
          data.Status.Datas.forEach(function (item) {
            let objfield = {};
            that.element.selectItemList.selectItem.forEach((element, index) => {
              // debugger;
              if (element.bindingField) {
                objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
              }
            });
            that.dataArrayList.push(objfield);
            
            // console.log(that.element.selectItemList.selectItem);
            //console.log(that.dataArrayList);
          });
          that.dataArrayList.forEach(items => {
            if (!items.orderNumber.value) {
              items.orderNumber.value = false;
              _isCheckAll = false;
            }
            else{
              that.bindSeesionLink(items,true);
            }
          });
        }
        let _tempCount:Array<any> =JSON.parse(sessionStorage.getItem("catlist"))||[];
        num=_tempCount.length;
        that.baseService.FixedSubmitBtn.count=num;
        /**
         * 初始化数据时，设置全选状态
         */
        if (_isCheckAll) {
          that.baseService.FixedSubmitBtn["isCheckAll"] = true;
        } else {
          that.baseService.FixedSubmitBtn["isCheckAll"] = false;
        }
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.Datas.length;
        if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length) {
          // that.infiniteScroll.disabled = true;
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = true;
          }
        } else {
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }
  EventBox(eve,item){
    // debugger;
    const that=this;
    if(eve.target.checked){
      if(that.baseService.FixedSubmitBtn.count<0){
        that.baseService.FixedSubmitBtn.count=0;
      }
      that.baseService.FixedSubmitBtn.count++;
    }else{
      that.baseService.FixedSubmitBtn.count--;
    }
   setTimeout(()=>{
     if(that.baseService.FixedSubmitBtn.count>=0){
      that.bindSeesionLinkList(item,eve.target.checked);
     }
   },300);
  }
  /**
   * 购物车删除
   * @param item 
   * @param i 
   */
  delete(item,i){
    const that=this;
    console.log(item);
    let name=item.b_ShortName;
    if(!name){
      name=item.b_ProductName;
    }
    if(item.j_Name){
      name+=" "+item.j_Name;
    }
    that.msg.Confirm("确定删除【"+name+"】产品吗？","取消","确定").then(data=>{
      if(data){
        that.dataArrayList.splice(i,1);
        that.baseService.FixedSubmitBtn.count=that.dataArrayList.length;
        sessionStorage.setItem("catlist",JSON.stringify(that.dataArrayList));
      }
    });
  }
  EventLink(parms: any, index) {
    let that = this;
    parms['a_isdistributed'] = !parms['a_isdistributed'];
    let _isCheckAll = true;
    that.dataArrayList.forEach(items => {
      if (!items.a_isdistributed) {
        _isCheckAll = false;
      }
    });
    if (_isCheckAll) {
      that.baseService.FixedSubmitBtn["isCheckAll"] = true;
    } else {
      that.baseService.FixedSubmitBtn["isCheckAll"] = false;
    }
  }
  /**
   * 全选状态切换
   */
  EventCheckAllToggle() {
    const that = this;
    let _arrayList:Array<any> = new Array<any>();
    if (that.baseService.FixedSubmitBtn["isCheckAll"]) {
      that.dataArrayList.forEach(items => {
        items.DetailList.forEach(check=>{
          check.a_isdistributed=true;
          _arrayList.push(check);
        });
      });
      that.baseService.FixedSubmitBtn.count=_arrayList.length;
      sessionStorage.setItem("catlist",JSON.stringify(_arrayList));
    } else {
      that.dataArrayList.forEach(items => {
        items.DetailList.forEach(check=>{
          check.a_isdistributed=false;
        });
      });
      that.baseService.FixedSubmitBtn.count=0;
      sessionStorage.setItem("catlist",JSON.stringify([]));
    }
  }
  bindSeesionLink(item:any,istype:boolean){
    // debugger;
    item.orderNumber.value=istype;
    let temp:Array<any>=new Array<any>();
    let carList:Array<any>=new Array<any>();
        carList= JSON.parse(sessionStorage.getItem("catlist"))||[];
        if(carList.length>0){
          if(carList.find(tool=>tool.orderID.value==item.orderID.value)){
             if(!istype){
                carList=carList.filter(tool=>tool.orderID.value!=item.orderID.value);
              }
          }else{
            carList.push(item);
          }
        }else{
          carList.push(item);
        }
        temp=carList;
        this.baseService.FixedSubmitBtn.count=temp.length;
        sessionStorage.setItem("catlist",JSON.stringify(temp));
  }
  /**
   * 购物车
   * @param item 
   * @param istype 
   */
  bindSeesionLinkList(item:any,istype:boolean){
    // debugger;
    item.a_isdistributed=istype;
    let temp:Array<any>=new Array<any>();
    let carList:Array<any>=new Array<any>();
        carList= JSON.parse(sessionStorage.getItem("catlist"))||[];
        if(carList.length>0){
          if(carList.find(tool=>tool.b_ID==item.b_ID)){
             if(!istype){
                carList=carList.filter(tool=>tool.b_ID!=item.b_ID);
              }
          }else{
            carList.push(item);
          }
        }else{
          carList.push(item);
        }
        temp=carList;
        this.baseService.FixedSubmitBtn.count=temp.length;
        sessionStorage.setItem("catlist",JSON.stringify(temp));
  }
  EventClick() {
    const that = this;
    // debugger;
    // if (!that.isbutton) {
    //   that.isbutton = true;
    // } else {
    //   return;
    // }
    let _newarrayList:Array<any> = new Array<any>();
       _newarrayList=that.dataArrayList;
    if(that.pageName=="ProductDistribution" && sessionStorage.getItem("catlist")){
      _newarrayList=JSON.parse(sessionStorage.getItem("catlist"))||[];
    }
    const indexs: Number =_newarrayList.findIndex(items => items.a_ID);//判断当前是编辑还是新增
    const dataNum: Number = _newarrayList.findIndex(items => items.a_isdistributed);//判断当前是否有值存在

    if (dataNum < 0 && indexs < 0) {
      that.msg.Alert("请选择产品");
      that.isbutton = false;
      return;
    }

    let _dataList: Array<any> = new Array<any>();
    let tbstoreID = null;
    if (that.com.GetStorageKey("tbstore")) {
      tbstoreID = that.com.GetStorageKey("tbstore")["ID"];
    }
    _newarrayList.forEach(item => {
      let array = {};
            array["a_FK_SystemUser_ID"] = that.com.GetAccount.Id;
              array["a_FK_Store_ID"] = tbstoreID;
              array["a_FK_TBProductInformation_ID"] = item.b_ID;
              array["a_isdistributed"] = true;
          _dataList.push(array);
    });
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "TBProductCheck1XML";
    body.OpType = "ADD";
    body.ConfigType = "form";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 0;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    body.RequestBody = JSON.stringify(_dataList);
    //  return;
    if (!that.isProduct) {
      that.isProduct = true;
      that.msg.Confirm("确认分销吗?", "取消", "确定", "", false).then(res => {
        if (res) {
          that.msg.Loading("数据提交中...").then(loads => {
            that.http.post(app.DEFAULTURL, body).then(data => {
              that.isbutton = false;
              /****判断是否第一页end****/
              that.isProduct = false;
              loads.dismiss();
              if (data.ResponseMessage.Success) {
               
                 that.msg.Alert("分销成功").then(data=>{    
                    if(data){
                      sessionStorage.removeItem("catlist");
                      that.com.goBack();
                    }
                 })
                // that.native.QRCodeinfo(that.qrcode.nativeElement, data.Status);
              } else {
                loads.dismiss();
                that.msg.Alert(data.ResponseMessage.ErrorMessage);
              }
            }).catch(error => {
              loads.dismiss();
              that.isbutton = false;
              that.isProduct = false;
              console.log(error);
            });
            loads.present();

          });
        }else{
          that.isbutton = false;
          that.isProduct = false;
        }
      })
    }
  }
}